import { Component, ViewChild, OnDestroy, OnInit} from '@angular/core';
import { TransactionService } from 'src/app/services/transactionservice';
import { TransactionData, TransactionGridData } from '../../DTO/transaction';
import { TransactionSearchModel } from '../../DTO/transaction-search-model';
import { FormControl,FormGroup,Validators } from '@angular/forms';
import { Observable, map, startWith } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';

import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { formatDate, DatePipe } from "@angular/common";
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-transaction-search',
  templateUrl: './transaction-search.component.html',
  styleUrls: ['./transaction-search.component.css'],
})
export class TransactionSearchComponent {
  section1=["MessageId","RelatesToMessageId"];
  section2=["PharmacyNcpdpid","PatientLastName","PatientDateOfBirth","Species","MessageType","Status","PharmacyVendor","BeginDate", "BeginDateTime", "EndDate", "EndDateTime"];
  showError:boolean=false;
  enableSearch:boolean=false;
  form!: FormGroup;
  today = new Date();
  MessageId!: FormControl;
  RelatesToMessageId!: FormControl;
  PharmacyNcpdpid!: FormControl;
  Status!: FormControl;
  MessageType!: FormControl;
  Species!: FormControl;
  PatientLastName!: FormControl;
  PatientDateOfBirth!: FormControl;
  BeginDate!: FormControl;
  EndDate!: FormControl;
  BeginDateTime!:FormControl
  EndDateTime!:FormControl
  PharmacyVendor!:FormControl;


  dataSource:any;
  vendorList:any;
  speciesList:any;
  statusList:any;
  messageTypeList:any;
  displayedColumns: any[] = ['MessageID', 'RelatesToMessageID','PharmacyName','PatientLastName','PatientDOB','Species','MessageType','RequestDate','ResponseStatus'];
  transactionSearchModel=new TransactionSearchModel();
  transactionGridData=new TransactionGridData();
  transactionData = new TransactionData();
  minDate=new Date(new Date().setDate(new Date().getDate()-60))
  filteredOptions: Observable<any> | undefined;

  pageSizeOptions:any=[10,20,30,100];
  transactionFilter:string='';
  transactionPagesize:number =10;
  transactionPageNumber:number =1;
  resultTableHeight:string="180px";

  panelOpenState = false;

showFilter:string="Hide Filter"

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  length:number | undefined;
  isLoading: boolean=false;
  ngOnInit(): void {
    this.enableSearch=false;
    this.createFormControls();
    this.createForm();
    this.transactionPageNumber=1;
    this.filteredOptions = this.PharmacyVendor.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
    this.LoadSpecies();
    this.LoadStatus();
    this.LoadMessageType();
    this.LoadVendors();
    this.enableSearch=true;
  }

  constructor(private transactionservice: TransactionService,private router: Router,private toastr:ToastrService,
    private datePipe: DatePipe) {

  }
  ExportToExcel()
  {
    if(this.dataSource!=null && this.dataSource.filteredData.length>0)
    {
      let transactionArray: { "Message Id": any; "Relates To Message Id": any; "Pharmacy Chain Name": any;
       "Patient Last Name": any; "Patient DOB": any; "Species": any;
        "Message Type": any; "Transaction Date and Time": any; "Transaction Status": any;
         "Initiator": any; }[]=[];
    
    this.transactionSearchModel.PageNumber=this.transactionPageNumber;
    this.transactionSearchModel.PageSize=this.length;
    this.transactionservice.getTransactionGrid(this.transactionSearchModel)
        .subscribe(res => {
          res.transactionData.forEach((transactionModel: any)=> {
            transactionArray.push(
            {
              "Message Id":transactionModel.MessageID,
              "Relates To Message Id":transactionModel.RelatesToMessageID,
              "Pharmacy Chain Name":transactionModel.PharmacyName,
              "Patient Last Name":transactionModel.PatientLastName,
              "Patient DOB":transactionModel.PatientDOB,
              "Species":transactionModel.Species,
              "Message Type":transactionModel.MessageType,
              "Transaction Date and Time":transactionModel.RequestDate,
              "Transaction Status":transactionModel.ResponseStatus,
              "Initiator":transactionModel.Initiator,
            })
           });
          const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(JSON.parse(JSON.stringify(transactionArray)));
          const wb: XLSX.WorkBook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      
          XLSX.writeFile(wb, 'Transactions.csv');
  })
}
else{
  this.toastr.error("No transactions to export");
}
  }
 
  createFormControls() {
    this.MessageId = new FormControl('', [Validators.maxLength(35),Validators.pattern("^[A-Za-z0-9]+$")]);
    this.RelatesToMessageId = new FormControl('', [Validators.maxLength(35),Validators.pattern("^[A-Za-z0-9]+$")]);
    this.PharmacyNcpdpid = new FormControl('', [Validators.maxLength(7),Validators.pattern("[0-9]+$")]);
    this.PatientLastName = new FormControl('', [Validators.maxLength(35),Validators.pattern("^[A-Za-z0-9]+$")]);
    this.BeginDate = new FormControl(new Date());
    this.EndDate = new FormControl(new Date());
    this.BeginDateTime = new FormControl({ hour: 0, minute: 1});
    this.PatientDateOfBirth= new FormControl();
    this.EndDateTime = new FormControl({ hour: new Date().getHours(), minute: new Date().getMinutes()});
    this.Species = new FormControl('All');
    this.Status = new FormControl('All');
    this.MessageType = new FormControl('All');
    this.PharmacyVendor=new FormControl();
    
  }
  createForm() {
    this.form = new FormGroup({
      MessageId: this.MessageId,
      RelatesToMessageId: this.RelatesToMessageId,
      PharmacyNcpdpid: this.PharmacyNcpdpid,
      PatientLastName: this.PatientLastName,
      BeginDate: this.BeginDate,
      EndDate: this.EndDate,
      BeginDateTime: this.BeginDateTime,
      EndDateTime: this.EndDateTime,
      Species: this.Species,
      Status: this.Status,
      MessageType: this.MessageType,
      PatientDateOfBirth:this.PatientDateOfBirth,
      PharmacyVendor:this.PharmacyVendor
    });
  }
  getTransactionModel()
  {
    this.transactionSearchModel=new TransactionSearchModel();
        this.transactionSearchModel.MessageId = this.form.get('MessageId')?.value;
        this.transactionSearchModel.RelatesToMessageId = this.form.get('RelatesToMessageId')?.value;
        this.transactionSearchModel.PharmacyNcpdpid = this.form.get('PharmacyNcpdpid')?.value;
        this.transactionSearchModel.PatientLastName = this.form.get('PatientLastName')?.value;
        this.transactionSearchModel.PatientDOB =this.form.get('PatientDateOfBirth')?.value==null?null:formatDate(this.form.get('PatientDateOfBirth')?.value, 'yyyy-MM-dd', 'en-US');
        if(this.transactionSearchModel.MessageId || this.transactionSearchModel.RelatesToMessageId){
          let startDate= new Date();
          startDate.setDate(startDate.getDate()-60);
          let endDate= new Date();
          this.transactionSearchModel.StartDate =this.datePipe.transform(startDate, 'yyyy-MM-dd');
          this.transactionSearchModel.EndDate = this.datePipe.transform(endDate, 'yyyy-MM-dd');
        }
        else
        {
          this.transactionSearchModel.StartDate =formatDate(this.form.get('BeginDate')?.value, 'yyyy-MM-dd', 'en-US');
          this.transactionSearchModel.EndDate = formatDate(this.form.get('EndDate')?.value, 'yyyy-MM-dd', 'en-US');
        }
        this.transactionSearchModel.BeginDateTime = this.form.get('BeginDateTime')?.value;
        this.transactionSearchModel.EndDateTime = this.form.get('EndDateTime')?.value;
        if(this.form.get('PharmacyVendor')?.value!=null && this.form.get('PharmacyVendor')?.value["PharmacyId"]==undefined)
        {
          let pharmacyVendor=this.vendorList.find((x: { PharmacyName: any; })=>x.PharmacyName.toLowerCase()==this.form.get('PharmacyVendor')?.value.toLowerCase());
          this.form.get('PharmacyVendor')?.setValue(pharmacyVendor!=undefined && pharmacyVendor !=null?pharmacyVendor:null);
        }
        this.transactionSearchModel.PharmacyVendor = this.form.get('PharmacyVendor')?.value;//this.vendorData;
        this.transactionSearchModel.PharmacyId = this.transactionSearchModel.PharmacyVendor!=null?this.transactionSearchModel.PharmacyVendor.PharmacyId:null;
        this.transactionSearchModel.PharmacyName=this.transactionSearchModel.PharmacyVendor!=null?this.transactionSearchModel.PharmacyVendor.PharmacyName:null;
        this.transactionSearchModel.IsPet = this.form.get('Species')?.value=='All' || this.form.get('Species')?.value==null?null: this.form.get('Species')?.value=="Pet Only"?"1":"0";
        this.transactionSearchModel.ResponseStatus = this.form.get('Status')?.value=='All' || this.form.get('Status')?.value==null ? null : this.form.get('Status')?.value;
        this.transactionSearchModel.MessageType = this.form.get('MessageType')?.value=='All' || this.form.get('MessageType')?.value==null ? null : this.form.get('MessageType')?.value;
  }
  showHideFilter()
  {
    if(this.showFilter=="Hide Filter")
    {
this.showFilter="Show Filter"
    }
    else{
      this.showFilter="Hide Filter"
    }
  }
  submitForm() {
    if (this.form.valid) {
      this.isLoading = true;
      this.getTransactionModel();
      let div=document.getElementById('mat_sidenav_content') as HTMLDivElement;
      div.classList.remove("custom-content-default");
      div.classList.add("custom-content-search-transaction");
      this.resultTableHeight="600px";
        console.log(this.transactionSearchModel)

        this.LoadTransactionsGrid(false);
    }
  }

private LoadTransactionsGrid(clearTable:boolean)
{
  if(clearTable)
  {
    this.transactionGridData=new TransactionGridData();
    this.length=0;
    if (this.dataSource!=undefined && this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.dataSource=null;
  }
  else{
  this.transactionSearchModel.PageNumber=this.transactionPageNumber;
  this.transactionSearchModel.PageSize=this.transactionPagesize;
  this.isLoading = true; // Add Loading icon at the start of LoadTransactionsGrid
  this.transactionservice.getTransactionGrid(this.transactionSearchModel)
        .subscribe(res => {
          this.transactionGridData = res;
      this.dataSource = new MatTableDataSource(this.transactionGridData.transactionData);
      
      this.isLoading = false;

      this.dataSource.sort = this.sort;
      
      this.length=res.pagination.TotalItems;
      
        },(error: any)=>{
          this.isLoading=false;
          this.toastr.error(error);
        });
      }
}
onPageEvent(event:any){
  this.transactionPagesize=event.pageSize;
  this.transactionPageNumber=event.pageIndex+1;
  this.isLoading = true; // Show spinner while refreshing
  if(this.dataSource!=null){
  this.LoadTransactionsGrid(false);
  }
}

  private _filter(value: any): string[] {
    const filterValue = value!=undefined && value!="" && value["PharmacyName"]!=undefined? value["PharmacyName"].toLowerCase():value.toLowerCase();
if(this.vendorList!=undefined)
{
    return this.vendorList.filter((option: any) => option["PharmacyName"].toLowerCase().includes(filterValue));
}
else{
  return [];
}
  }
  displayTextForVendor(vendor:any)
  {
    return vendor!=undefined && vendor!=''?vendor.PharmacyName:"";
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  LoadVendors(searchTerm: string = '', pageNumber: number = 1, pageSize: number = 500)
  {
    this.transactionservice.getPharmacyVendors(searchTerm, pageNumber, pageSize).subscribe((res) => {
      
      this.vendorList = res?.ResponseData?.ResponseData;
      this.filteredOptions = this.PharmacyVendor.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value || '')),
      );
    });

  }
  LoadSpecies(){
    this.speciesList=[
      {
      "SpeciesId":"S001","SpeciesName":"Pet Only"
    },
    {
      "SpeciesId":"S002","SpeciesName":"Human Only"
    },
    {
      "SpeciesId":"null","SpeciesName":"All"
    }
  ]
  }
  LoadStatus(){
  this.statusList=[
  {
    "StatusId":"All","StatusName":"All"
  },
  {
    "StatusId":"Status","StatusName":"Status"
  },
  {
    "StatusId":"Error","StatusName":"Error"
  },
  {
    "StatusId":"Verify","StatusName":"Verify"
  }
]
  }

  LoadMessageType(){
    this.messageTypeList=[
      {
        "Id":"All","Name":"All"
      },
      {
        "Id":"NewRx","Name":"New Request"
      },
      {
        "Id":"CancelRx","Name":"Cancel Request"
      },
      {
        "Id":"RxRenewalRequest","Name":"Renewal Request"
      },
      {
        "Id":"RxChangeRequest","Name":"Change Request"
      },
      {
        "Id":"RxChangeResponse","Name":"Change Response"
      },
      {
        "Id":"RxRenewalResponse","Name":"Renewal Response"
      },
      {
        "Id":"CancelRxResponse","Name":"Cancel Response"
      }
    ]
  }
  
  get errorMessageForMessageId(): string {
    const transactionform: FormControl = (this.form.get('MessageId') as FormControl);
    return transactionform.hasError('required') ?
      'Required error message' :
      transactionform.hasError('maxlength') ?
      'Max length is 35 characters' : 
      transactionform.hasError('pattern') ?
      'Please enter only alphanumeric values':""
 }
 get errorMessageForRelatesToMessageId(): string {
  const transactionform: FormControl = (this.form.get('RelatesToMessageId') as FormControl);
  return transactionform.hasError('required') ?
    'Required error message' :
    transactionform.hasError('maxlength') ?
    'Max length is 35 characters' : 
    transactionform.hasError('pattern') ?
    'Please enter only alphanumeric values':""
}
get errorMessageForPharmacyNcpdpid(): string {
  const transactionform: FormControl = (this.form.get('PharmacyNcpdpid') as FormControl);
  return transactionform.hasError('required') ?
    'Required error message' :
    transactionform.hasError('maxlength') ?
    'Max length is 7 characters' : 
    transactionform.hasError('pattern') ?
    'Please enter only numeric values':""
}
get errorMessageForPharmacyLastname(): string {
  const transactionform: FormControl = (this.form.get('PatientLastName') as FormControl);
  return transactionform.hasError('required') ?
  'Patient Last Name is mandatory' :
  transactionform.hasError('maxlength') ?
    'Max length is 35 characters' : 
    transactionform.hasError('pattern') ?
    'Please enter only alphanumeric values':"";
}
get errorMessageForPatientDOB():string{
  const transactionform: FormControl = (this.form.get('PatientDateOfBirth') as FormControl);
  return transactionform.hasError('matDatepickerParse') ?
  'Invalid date' :
  transactionform.hasError('mandatory') ?
  'Patient Date Of Birth is mandatory':transactionform.hasError('futuredateerror')?
  "Future date is not allowed":""
}
get errorMessageForBeginDate():string{
  const transactionform: FormControl = (this.form.get('BeginDate') as FormControl);
  return transactionform.hasError('matDatepickerParse') ?
  'Invalid date' :
  transactionform.hasError('date error') ?
  'Begin date should be less than end date':
  transactionform.hasError('beginmindate error') ?
  'Dates should be prior to 60 days from current date':""
}
get errorMessageForEndDate():string{
  const transactionform: FormControl = (this.form.get('EndDate') as FormControl);
  return transactionform.hasError('matDatepickerParse') ?
  'Invalid date' :
  transactionform.hasError('date error') ?
  'End date should be greater than Begin date':
  transactionform.hasError('endmindate error') ?
  'Dates should be prior to 60 days from current date':""
}

dateValidation(element:string)
{
  let begintime=this.form.get('BeginDateTime')?.value;
  let endtime=this.form.get('EndDateTime')?.value;
   let beginDate=new Date(Date.parse(this.form.get('BeginDate')?.value))
   let endDate=new Date(Date.parse(this.form.get('EndDate')?.value))
   beginDate=new Date(beginDate.getFullYear(), beginDate.getMonth(), beginDate.getDate());
   endDate=new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
   this.minDate=new Date(this.minDate.getFullYear(), this.minDate.getMonth(), this.minDate.getDate());
  this.form.get('BeginDate')?.setValue(!isNaN(beginDate.getHours())?beginDate:null);
  this.form.get('EndDate')?.setValue(!isNaN(endDate.getHours())?endDate:null);
  
  if(element=='BeginDate')
  {
    if (this.form.get('BeginDate')?.value!=null && isNaN(beginDate.getHours())) {
      this.BeginDate.setErrors({'matDatepickerParse': true});
      this.form.get('BeginDate')?.markAsTouched();
      return;
      
    }
    if(beginDate<this.minDate)
  {

    this.BeginDate.setErrors({'beginmindate error': true});
    this.form.get('BeginDate')?.markAsTouched();
    return;
   
  }
  }
  else{
    if (this.form.get('EndDate')?.value!=null && isNaN(endDate.getHours())) {
  
      this.EndDate.setErrors({'matDatepickerParse': true});
      this.form.get('EndDate')?.markAsTouched();
      return;
 
    }
    if(endDate<this.minDate)
  {
  
    this.EndDate.setErrors({'endmindate error': true});
    this.form.get('EndDate')?.markAsTouched();
    return;
   
  }
  }
  
    if((isNaN(beginDate.getHours()) && this.form.get('EndDate')?.value!=null) ||
    (isNaN(endDate.getHours()) && this.form.get('BeginDate')?.value!=null) || 
    (beginDate>endDate))
    {
      this.BeginDate.setErrors({'date error': true});
      this.EndDate.setErrors({'date error': true});
      this.form.get('BeginDate')?.markAsTouched();
      this.form.get('EndDate')?.markAsTouched();
    }
    else{
        this.BeginDate.setErrors(null);
      this.EndDate.setErrors(null);
      
    }
}
onDateSelect(event:any){
  this.dateValidation(event.targetElement.name);
}
onTimeChange(elementName:string)
{
  this.dateValidation(elementName);
}
onDobDateSelect(event:any){
  if(this.section1.indexOf(event.targetElement.name)>=0)
    this.disableSection("section1");
  else if(this.section2.indexOf(event.targetElement.name)>=0)
    this.disableSection("section2");
  if(this.form.get('PatientDateOfBirth')?.value!=''
  && this.form.get('PatientDateOfBirth')?.value!=null && this.form.get('PatientDateOfBirth')?.value!=undefined
  && (this.form.get('PatientLastName')?.value==''
  || this.form.get('PatientLastName')?.value==null || this.form.get('PatientLastName')?.value==undefined))
  {
    this.form.get('PatientLastName')?.setErrors({'required': true});
    this.form.get('PatientLastName')?.markAsTouched();
  }
  else{
    if(!this.form.get('PatientLastName')?.hasError)
    {
    this.form.get('PatientLastName')?.setErrors(null);
    }
  }
}
disableSection(section:string)
{
  if(section=="section1")
  {
    
    if(this.checkForValueInSection("section1"))
    {
      for(let element of this.section2){
      this.form.get(element)?.disable()
      }
    }
    else{
      for(let element of this.section2){
        this.form.get(element)?.enable()
    }
    }
  }
  else if(section=="section2")
  {
    if(this.checkForValueInSection("section2"))
    {
      for(let element of this.section1){
      this.form.get(element)?.disable()
      }
      
    }
    else{
      for(let element of this.section1){
        this.form.get(element)?.enable()
    }
      
    }
  }
}
onDateInputkeyup(event:any)
{
      this.form.get('BeginDate')?.markAsTouched();
    this.form.get('EndDate')?.markAsTouched();
}

onInputkeyup(event:any)
{
  if(this.section1.indexOf(event.target.name)>=0)
    this.disableSection("section1");
  else if(this.section2.indexOf(event.target.name)>=0)
    this.disableSection("section2");
  this.validatePatientLastNameAndDob(event);
  if(event.currentTarget.name=="MessageId" || event.currentTarget.name=="RelatesToMessageId")
  {
    this.form.get('Species').setValue("All");
  }
  if(event.currentTarget.name=="PharmacyVendor")
  {
  if(this.form.get('PharmacyVendor')?.value!=null && this.form.get('PharmacyVendor')?.value!='')
        {
          let pharmacyVendor=this.vendorList.find((x: { PharmacyName: any; })=>x.PharmacyName.toLowerCase()==this.form.get('PharmacyVendor')?.value.toLowerCase());
          if(pharmacyVendor==undefined)
          {
            this.form.get('PharmacyVendor')?.setErrors({'invalid': true});
          }
          else{
            this.form.get('PharmacyVendor')?.setErrors(null);
          }
        }
        else{
          this.form.get('PharmacyVendor')?.setErrors(null);
        }
      }
}
validatePatientLastNameAndDob(event:any)
{
  let patientLastName=this.PatientLastName.value;
    let patientDob=this.PatientDateOfBirth.value;
  if(event.currentTarget.name=="PatientLastName")
  {
    let regex=new RegExp('^[A-Za-z0-9]+$')
    if(patientLastName.length>0 && !regex.test(patientLastName))
    {
      this.form.get('PatientLastName')?.setErrors({'pattern': true});
      return;
    }
    else if(patientLastName.length>35)
    {
      this.form.get('PatientLastName')?.setErrors({'maxlength': true});
      return;
    }
  if(patientLastName!=''&& patientDob==null )
  {
    this.form.get('PatientDateOfBirth')?.setErrors({'mandatory': true});
    this.form.get('PatientDateOfBirth')?.markAsTouched();
  }
  else{
    this.form.get('PatientDateOfBirth')?.setErrors(null);
  }
  if(patientLastName=='' && patientDob!=null )
  {
    this.form.get('PatientLastName')?.setErrors({'required': true});
  }
  else{
    if(!this.form.get('PatientLastName')?.hasError)
    {
    this.form.get('PatientLastName')?.setErrors(null);
    }
  }
}
if(event.currentTarget.name=="PatientDateOfBirth")
  {
    let patientDOB=new Date(Date.parse(this.form.get('PatientDateOfBirth')?.value))

    if(patientDOB>this.today)
    {
      this.form.get('PatientDateOfBirth')?.setErrors({'futuredateerror': true});
      return;
    }
    if(this.PatientDateOfBirth.hasError('matDatepickerParse'))
    {
      this.form.get('PatientDateOfBirth')?.setErrors({'matDatepickerParse': true});
      return;
    }
    if(patientLastName==''&& patientDob!=null )
  {
    this.form.get('PatientLastName')?.setErrors({'required': true});
    this.form.get('PatientLastName')?.markAsTouched();
  }
  else{
    this.form.get('PatientLastName')?.setErrors(null);
  }
  if(patientLastName!='' && patientDob==null )
  {
    this.form.get('PatientDateOfBirth')?.setErrors({'mandatory': true});
  }
  else{
    this.form.get('PatientDateOfBirth')?.setErrors(null);
  }
}
}
onChange(event:any)
{
  if(this.section1.indexOf(event.source._elementRef.nativeElement.id)>=0)
    this.disableSection("section1");
  else if(this.section2.indexOf(event.source._elementRef.nativeElement.id)>=0)
    this.disableSection("section2");
}

checkForValueInSection(section:string)
{
  let hasValue=false;
  if(section=="section1")
  {
    for(let element of this.section1){
      
      if(this.form.get(element)?.value!=undefined && this.form.get(element)?.value!=''
      && this.form.get(element)?.value!=null)
      {
        hasValue=true;
        this.enableSearch=true;
        break;
      }
      else{
        this.enableSearch=true;
      }
    }    
  }
  else if(section=="section2")
  {
    let novalue=false;
    for(let element of this.section2.filter(x=>x!="Species")){
      if(this.form.get(element)?.value!=undefined && this.form.get(element)?.value!=''
      && this.form.get(element)?.value!=null)
      {
        novalue=false;
        hasValue=true;
        this.enableSearch=true;
        break;
      }      
      else{
        novalue=true;
        this.enableSearch=false;
      }
    }
    if(novalue && this.form.get("Species")?.value=='All')
    {
      this.enableSearch=true;
      hasValue=false;
    }
    else if(novalue && this.form.get("Species")?.value!='All')
    {
      this.enableSearch=true;
      hasValue=true;
    }
  }
  
  return hasValue;
}
clearSearch()
{
  this.ngOnInit();
  this.LoadTransactionsGrid(true);
  let div=document.getElementById('mat_sidenav_content') as HTMLDivElement;
    div.classList.remove("custom-content-search-transaction");
    div.classList.add("custom-content-default");
    this.resultTableHeight="180px";
}
onClickTransactionId(id:string,initiator:string)
{
  window.open('summarytransaction/'+id+'/'+initiator);
}
ngOnDestroy() {
  let div=document.getElementById('mat_sidenav_content') as HTMLDivElement;
  div.classList.remove("custom-content-search-transaction");
  div.classList.add("custom-content-default");
}
compareVendors(v1: any, v2: any): boolean {
  return v1 && v2 ? v1.PharmacyId === v2.PharmacyId : v1 === v2;
}
}